import { getBillingSubscriptionApiRequest } from '@/services/api/billing-api';
import { useStore } from '@/store';

export const refreshBillingSubscriptionApiRequest = async () => {
  const store = useStore();
  store.setBilling(await getBillingSubscriptionApiRequest());
};
